// 缓存到本地的答案列表
export var LOCAL_QUES_ANSWERS = 'LOCAL_QUES_ANSWERS';

// 缓存本地的答案列表的uuid
export var LOCAL_QUES_ANSWERS_UUID = 'LOCAL_QUES_ANSWERS_UUID';